import React from 'react';
import styled from 'styled-components';
import { FaTools } from 'react-icons/fa';

// Style the wrapper
const StyledIconWrapper = styled.div`
  width: 25px;
  height: 25px;
  filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.3));
  transition: fill 0.2s ease;

  svg {
    width: 100%;
    height: 100%;
    color: #ffffff;
  }
`;

// Type FaTools as a proper React component
const TypedFaTools = FaTools as unknown as React.FC<{ size?: number | string }>;

const AssetsIcon: React.FC = () => (
  <StyledIconWrapper>
    <TypedFaTools size={24} />
  </StyledIconWrapper>
);

export default AssetsIcon;